<!-- background -->
<rid-mechanic-background />

<rid-mechanic-wrapper>
  <!-- top bar -->
  <rid-top-bar
    class="block w-full"
    name="Leeslijst | Geen tijd"
    [steps]="matrices().length"
    [progress]="state() === 'READING' ? index() : matrices().length"
  />

  <rid-mechanic-content>
    <!-- title -->
    @if (state() === 'READING') {
      <rid-mechanic-title [title]="'Lees de woorden hardop in je eigen tempo'" />
    }

    <!-- matrices -->
    <rid-horizontal-pages [pageCount]="matrices().length" (navigated)="index.set($event)">
      @for (matrix of matrices(); track $index) {
        <rid-word-matrix [matrix]="matrix" />
      }
    </rid-horizontal-pages>

    <!-- continue button(s) -->
    @if (state() === 'READING' && index() === matrices().length - 1) {
      <rid-bottom-button content="Klaar!" (clicked)="finishReading()" />
    }
    @if (state() === 'VIEWING') {
      <rid-bottom-button content="Volgende" (clicked)="finish()" />
    }

    <!-- overlay -->
    @if (state() === 'RATING') {
      <rid-modal-background />
      <rid-rating-modal (canceled)="view()" (continued)="finish()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
